import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentThreadArchived.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export const useTrackAgentThreadArchived = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentThreadArchived = useCallback(() => {
    track(META.name, withWorkspaceAgentCategory({}));
  }, [track]);

  return { trackAgentThreadArchived };
};
